import { useQueryClient } from '@tanstack/react-query';
import { useAddFavoriteGame, useDeleteFavoriteGame } from 'react-easyrocket';

export const useGameFavorites = (gameId: number) => {
  const queryClient = useQueryClient();

  const { mutate: addFavoriteGame, isLoading: isAddFavoriteLoading } = useAddFavoriteGame();
  const { mutate: deleteFavoriteGame, isLoading: isDeleteFavoriteLoading } =
    useDeleteFavoriteGame();

  const isFavoriteLoading = isAddFavoriteLoading || isDeleteFavoriteLoading;

  const toggleFavorite = (currentFavorite: boolean): boolean | undefined => {
    const newFavoriteState = !currentFavorite;
    if (currentFavorite) {
      deleteFavoriteGame(
        { game_id: gameId },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['games-favorites'] });
          }
        }
      );
    } else {
      addFavoriteGame(
        { game_id: gameId },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['games-favorites'] });
          }
        }
      );
    }

    return newFavoriteState;
  };

  return { toggleFavorite, isFavoriteLoading };
};
